import React, { useState, useEffect, useRef } from 'react';
import { TextField } from "@material-ui/core"
import { NotificationsActive } from "@material-ui/icons"
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector} from 'react-redux'
import TimeoutButton from '../../Common/TimeoutButton';
import { editException, getNewStorageInfo, updateOrderInfo, updateShippingStatus, getExceptionByState, getFailedReason, deliveryOperation} from '../../../actions/editOrderActions';
import { showAlertSnackbar } from '../../../reducers/uiSlice';
import { getBranchById, getUserPreference } from '../../../utilities/common';
import _ from 'lodash';
import { operationLog } from '../../../actions/commonAction';
import { useAlert, useToken } from '../../../utilities/hooks';
import { alertType } from '../../Common/UniAlert/context';
import TransshipmentDialog from './TransshipmentDialog';
import ExceptionDialog from './ExceptionDialog';
import FailedReasonDialog from './FailedReasonDialog';
import exceptions from '../../../constants/exceptions.json';
import { DialogContent, DialogContentText } from '@material-ui/core';
import UniDialog from "../../../components/Common/UniDialog";
import { RESTORE_TO_STATE } from '../../../actions/types';
import DeliveryOperationDialog from './DeliveryOperationDialog';

const NEXT_TRANSITION_STAFF_ID = 666;

const initialParcelInfo = {
    order_id: null,
    extra_order_sn: null,
    transition: null,
    status: null,
    desc: ""
}

export default function NextTransition(props){
    const { orderInfo, onTransitionUpdate } = props;
    const {t} = useTranslation('editOrder'); 
    const dispatch = useDispatch();
    const userPref = getUserPreference();
    const alertDialog = useAlert();
    const tokenContents = useToken();
    const fiterReasonCode = [211]

    const userUS = tokenContents.userUS;
    const CA_TELUS_PARTNER_ID = 36;

    const initialParam = {
        order_id: null,
        staff_id: NEXT_TRANSITION_STAFF_ID,
        shipping_status: 0,
        scan_location: "Default",
        send_sms: 0
    }

    // const warehouseList = useSelector(state => state.editOrder.warehouseList) || [];
    const warehouseList = useSelector(state => state.common.branches) || [];
    const nextTransitionList = useSelector(state => state.editOrder.nextTransitionList) || [];
    const isUpdateLoading = useSelector(state => state.editOrder.orderUpdateLoading) || false;
    const isUpdateScanStatusLoading = useSelector(state => state.editOrder.updateScanStatusLoading) || false;
    // const failedReasonList = useSelector(state => state.editOrder.failedReasonList) || [];

    const [nextTransitionLocation,setNextTransitionLocation] = useState("");
    const [nextTransition,setNextTransition] = useState("");

    const [openTransshipment, setOpenTransshipment] = useState(false);
    const [openExceptionDialog, setOpenExceptionDialog] = useState(false);
    const [loading, setLoading] = useState(false);

    const [exceptionList, setExceptionList] = useState([]);
    const [failedReasonList, setFailedReasonList] = useState([]);

    // const [failedReasonList, setFailedReasonList] = useState();
    const [operationMemo, setOperationMemo] = useState('');
    const [OpenFailedReasonDialog, setOpenFailedReasonDialog] = useState(false);

    const [deliveryOperationDialogOpen, setDeliveryOperationDialogOpen] = useState(false);
    const [deliveryOperationDialogLoading, setDeliveryOperationDialogLoading] = useState(false);

    const paramRef = useRef(initialParam);
    const parcelInfoRef = useRef(initialParcelInfo);
    const sendSMS = useRef(0);
    const smsSelected = useRef(false);
    const transshipmentNo = useRef("")
    const exceptionId = useRef(null)
    const failedReasonId = useRef(null)

    useEffect(() => {
        if(orderInfo) {
            if(orderInfo.orders) {
                setNextTransitionLocation(orderInfo.orders.warehouse);
                resetData()
                dispatch(getExceptionByState(219))
                    .then((res) => {
                        setExceptionList(res)
                    })
            }
        }
    }, [orderInfo])
    useEffect(() => {
        resetData()
    }, [nextTransition])
    useEffect(() => {
        dispatch(getFailedReason())
            .then((res) => {
                setFailedReasonList(res);
            })
    }, [])

    function resetData(){
        //Reset all changed data
        transshipmentNo.current = ""
        exceptionId.current = null
        failedReasonId.current = null
        paramRef.current = initialParam
        parcelInfoRef.current = initialParcelInfo
        sendSMS.current = 0
        smsSelected.current = true
    }

    return (
        <div style={{ width: '100%' }}>
            <TextField
                id="nextOperationLocation"
                fullWidth
                select
                label={t('operation_location')}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                value={nextTransitionLocation}
                onChange={(e) => { setNextTransitionLocation(e.target.value) }}
                style={{ paddingBottom: 16 }}
            >
                <option value="">
                    {t('select_location')}
                </option>
                {warehouseList.map((item) => (
                    <option key={item.name} value={item.id}>
                        {item.name}
                    </option>
                ))}
            </TextField>
            <TextField
                id="nextTransition"
                fullWidth
                select
                label={t('next_transition')}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                value={nextTransition}
                onChange={(e) => { setNextTransition(e.target.value) }}
                style={{ paddingBottom: 16 }}
            >
                <option value="">
                    {t('select_transition')}
                </option>
                {nextTransitionList.map((item) => (
                    <option key={item.transition} value={item}>
                        {item.transition}
                    </option>
                ))}
            </TextField>
            <TextField
                fullWidth
                multiline
                rows={2}
                id="nexttrasition_add_operationmemo_textfield"
                variant="outlined"
                label={t('note')}
                InputLabelProps={{ shrink: true }}
                style={{ paddingBottom: 16 }}
                value={operationMemo}
                onChange={(e) => { setOperationMemo(e.target.value) }}
            />
            <TimeoutButton
                variant="contained"
                color='secondary'
                id="nexttrasition_submit_timeout_button"
                timeout={2000}
                fullWidth
                startIcon={<NotificationsActive />}
                disabled={!nextTransitionLocation || !nextTransition.transition || isUpdateScanStatusLoading}
                onClick={handleNextTransitionSubmit}
            >
                {t('button_submit')}
            </TimeoutButton>
            <TransshipmentDialog
                open={openTransshipment}
                onClose={() => {
                    setOpenTransshipment(false)
                    resetData()
                }}
                onFinish={(value) => {
                    transshipmentNo.current = value
                    updateNextTransition()
                }}
            />
            <ExceptionDialog
                exceptions={nextTransition.to_code === 219 ? exceptionList : exceptions}
                open={openExceptionDialog}
                onClose={() => {
                    setOpenExceptionDialog(false)
                    resetData()
                }}
                onFinish={(value) => {
                    exceptionId.current = value
                    updateNextTransition()
                }}
            />
            <FailedReasonDialog
                failedReasons={failedReasonList}
                open={OpenFailedReasonDialog}
                onClose={() => {
                    setOpenFailedReasonDialog(false)
                    resetData()
                }}
                onFinish={(value) => {
                    failedReasonId.current = parseInt(value);
                    if (nextTransition.to_code === 211) {
                        handleParcelReturn();
                    } else {
                        updateNextTransition()
                    }
                }}
            />
            <DeliveryOperationDialog
                open={deliveryOperationDialogOpen}
                onClose={()=>setDeliveryOperationDialogOpen(false)}
                onFinish={handleDeliveryOperation}
                loading={deliveryOperationDialogLoading}
            />
        </div>
    )

    async function handleDeliveryOperation(pods) {
        let podStandard = true;
        pods.forEach(pod => {
            if(!pod) {
                dispatch(showAlertSnackbar({message: t('two_pod_required'), type: 'warning'}));
                podStandard = false;
                return;
            }
        });
        if(podStandard) {
            try {
                let formData = new FormData();
                
                formData.append('order_id', orderInfo.orders.order_id);
                formData.append('delivery_result', 0);
                formData.append('pod_images[]', pods[0]);
                formData.append('pod_images[]', pods[1]);

                setDeliveryOperationDialogLoading(true);
                
                await dispatch(deliveryOperation(formData, userPref.userCity));
                await dispatch(operationLog(orderInfo.orders.order_id, userPref.username, nextTransition.to_code, 0, '', operationMemo))
                await onTransitionUpdate();
                await dispatch(showAlertSnackbar({message: t('status_update_success'), type: 'success'}));
                setDeliveryOperationDialogOpen(false);
            } catch {
                dispatch(showAlertSnackbar({message: t('status_update_fail'), type: 'error'}));
            } finally {
                setOperationMemo('');
                setDeliveryOperationDialogLoading(false);
            }
        }
    }

    async function handleParcelReturn() {
        try {
            let formData = new FormData();
            formData.append('order_id', orderInfo.orders.order_id);
            formData.append('delivery_result', 1);
            formData.append('failed_reason', failedReasonId.current);

            setDeliveryOperationDialogLoading(true);

            await dispatch(deliveryOperation(formData, userPref.userCity));
            await dispatch(operationLog(orderInfo.orders.order_id, userPref.username, nextTransition.to_code, 0, '', operationMemo))
            await onTransitionUpdate();
            await dispatch(showAlertSnackbar({ message: t('status_update_success'), type: 'success' }));
            setDeliveryOperationDialogOpen(false);
        } catch {
            dispatch(showAlertSnackbar({ message: t('status_update_fail'), type: 'error' }));
        } finally {
            setOperationMemo('');
            setDeliveryOperationDialogLoading(false);
        }
    }

    async function handleNextTransitionSubmit() {
        if(validateData(nextTransitionLocation, nextTransition.transition)){
            if(nextTransition.to_code === 203) {
                setDeliveryOperationDialogOpen(true);
            } else if (nextTransition.to_code === 211) {
                setOpenFailedReasonDialog(true);
            } else {
                updateNextTransition();
            }
        }
    }

    //Where actual API calls and responses are handled
    async function updateStatus(params, parcelInfo, transshipmentNo, exceptionId, failedReasonId){
        setLoading(true)
        try{
            await dispatch(updateShippingStatus(params, parcelInfo, exceptionId, failedReasonId))
            if(transshipmentNo.length > 0){
                await dispatch(updateOrderInfo(params.order_id, {shipper: transshipmentNo}))
            }
            if(exceptionId !== null && exceptionId !== 0){
                await dispatch(editException(params.order_id, exceptionId))
                await dispatch(operationLog(params.order_id, userPref.username, 0, 2, 'OPERATION_EXCEPTION', operationMemo))
            }
            if(params['send_sms'] === 1){
                dispatch(showAlertSnackbar({
                    type: "success",
                    title: t('dialog:update_transition_title'), 
                    message: t('dialog:success_update_transition_sms_message')}));
                await dispatch(operationLog(params.order_id, userPref.username, 0, 1, 'SEND_MESSAGE', operationMemo))
            } else {
                dispatch(showAlertSnackbar({
                    type: "success",
                    title: t('dialog:update_transition_title'), 
                    message: t('dialog:success_update_transition_general_message')}));
                await dispatch(operationLog(params.order_id, userPref.username, nextTransition.to_code, 0, '', operationMemo))
            }
            onTransitionUpdate();
        }catch(error){
            //This API is a special case with error message, it's always a different structure
            dispatch(showAlertSnackbar({
                title: t('dialog:update_transition_title'), 
                message: t('dialog:failed_update_transition_general_message')
                
            }))
        }finally{
            setOperationMemo('');
        }
        resetData()
        setLoading(false)
    }

    function validateData(nextLocation, nextTransition){
        let isValid = true
        let message = ""
        if (!nextLocation) {
            isValid = false;
            message = t('dialog:validation_transition_location')
        }    
    
        if (!nextTransition) {
            isValid = false;
            message = t('dialog:validation_transition')
        }

        if(!isValid){
            dispatch(showAlertSnackbar({title: t('dialog:update_transition_title'), message: message}));
        }
        
        return isValid
    }

    //Connivent functions
    function generateParams(currentParams){
        const STATES_STAFF_ID_SHIPPING_STAFF_ID_LIST = [203, 220, 213, 226];
        currentParams['order_id'] = Number(orderInfo.tracking.order_id)
        currentParams['shipping_status'] = nextTransition.next_shipping_status
        currentParams['scan_location'] = getBranchById(nextTransitionLocation).name
        currentParams['send_sms'] = sendSMS.current
        currentParams['storaged_warehouse'] = nextTransitionLocation
        if(STATES_STAFF_ID_SHIPPING_STAFF_ID_LIST.includes(nextTransition.to_code)) {
            currentParams['staff_id'] = orderInfo.orders.shipping_staff_id;
        } else {
            currentParams['staff_id'] = NEXT_TRANSITION_STAFF_ID;
        }
        return currentParams
    }

    function generateParcelInfo(currentParcelInfo){
        currentParcelInfo["order_id"] = Number(orderInfo.tracking.order_id)
        currentParcelInfo["extra_order_sn"] = orderInfo.orders.order_sn
        currentParcelInfo["transition"] = nextTransition.transition
        currentParcelInfo["status"] = nextTransition.to_code
        currentParcelInfo["desc"] = ""
        currentParcelInfo["warehouse"] = nextTransitionLocation
        return currentParcelInfo
    }

    //A function that combines all the handling for different next codes
    //The aim for this function is to easily expand when more handling are required
    //They are not mutually exclusive, thus one next code can have multiple way to handle
    async function updateNextTransition(){
        let params = generateParams(paramRef.current) 
        let parcelInfo = generateParcelInfo(parcelInfoRef.current)

        // Not send pickup sms when parcel return to warehouse and partner_id === 36 -> TELUS
        if(canSendMessage(nextTransition.to_code) && !smsSelected.current) {
            //Display send message dialog
            alertDialog.addAlertDialog(
                t('dialog:update_transition_title'),
                t('send_immediately'), 
                alertType.INFO, 
                t('common:cancel'))
            alertDialog.addActionButton(
                t('send_without_sms'),
                ()=>{
                    smsSelected.current = true //flag to identify already made the choice
                    sendSMS.current = 0
                    updateNextTransition() //recursively called
                    alertDialog.hideAlert()
                }
            )
            alertDialog.addActionButton(
                t('send_with_sms'),
                ()=>{
                    smsSelected.current = true
                    sendSMS.current = 1
                    updateNextTransition()
                    alertDialog.hideAlert()
                },
                'primary')
            alertDialog.showAlert();
            return
        }

        if(requireTransshipment(nextTransition.to_code) && transshipmentNo.current.length <= 0){
            setOpenTransshipment(true)
            return
        }

        if(requireException(nextTransition.to_code) && exceptionId.current === null) {
            setOpenExceptionDialog(true)
            return
        }
        
        if(requireFilterReason(nextTransition.to_code) && failedReasonId.current === null) {
            setOpenFailedReasonDialog(true)
            return
        }

        let currentPath = _.last(orderInfo.path)
        if(currentPath !== undefined){
            if(canGenerateStorageInfo(currentPath.code ,nextTransition.to_code)){
                try{
                    let response = await dispatch(getNewStorageInfo(nextTransitionLocation))
                    parcelInfo['storage_info'] = response.storage_info;
                    parcelInfo['storage_code'] = response.storage_code;
                    parcelInfo['storage_rotation'] = response.storage_rotation;
                }catch(error){
                    dispatch(showAlertSnackbar({title: t('dialog:update_transition_title'), message: t('failed_update_storage_info_message')}));
                    resetData()
                    return
                }
            }
        }

        updateStatus(params, parcelInfo, transshipmentNo.current, exceptionId.current, failedReasonId.current)
    }

    function canSendMessage(nextCode){
        const sendMessageCodes = [214, 226]
        let codeIndex = _.findIndex(sendMessageCodes, (code) => code === nextCode)
        let canSend = false;
        if(codeIndex !== -1) {
            canSend = true;
        }
        if(!userUS) {
            canSend = canSend && orderInfo.orders.partner_id !== CA_TELUS_PARTNER_ID;
        }
        return canSend;
    }

    function canGenerateStorageInfo(currentCode, nextCode){
        const storageInfoCodes = [213, 214]
        const excludeCurrentCodes = [220]
        if(_.findIndex(excludeCurrentCodes, code => code === currentCode) !== -1)
            return false
        if(_.findIndex(storageInfoCodes, code => code === nextCode) !== -1) 
            return true
        else return false
    }

    function requireTransshipment(nextCode){
        const transshipmentCode = [217]
        if(_.findIndex(transshipmentCode, code => code === nextCode) !== -1)
            return true
        else return false
    }

    function requireException(nextCode){
        const exceptionCode = [204, 219]
        if(_.findIndex(exceptionCode, code => code === nextCode) !== -1)
            return true
        else return false
    }

    function requireFilterReason(nextCode){
        return fiterReasonCode.includes(nextCode);
    }
}